/* eslint-disable max-len */

import React from 'react'
import styled from 'styled-components'

const SetTheDateTutorialStyled = styled.div`
  position: absolute;
  bottom: -25px;
  right: 80%;
  z-index: 2;
`

export const TutorialContent = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: left;
  display: inline-block;
  width: 100%;

  letter-spacing: 1px;

  color: #000000;
`

const SetTheDateTutorial = () => (
  <SetTheDateTutorialStyled>
    <svg
      width="453"
      height="124"
      viewBox="0 0 453 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M311 53L373.341 69.3587L453 88L311 69.3587V53Z" fill="#D4D4FA" />
      <g filter="url(#filter0_d_2466_13459)">
        <rect x="24" y="5" width="287" height="111" rx="10" fill="#D4D4FA" />
        <rect x="24.5" y="5.5" width="286" height="110" rx="9.5" stroke="#D9D9D9" />
      </g>
      <circle cx="21" cy="21" r="20.5" fill="#3B82F6" stroke="#3B82F6" />
      <path
        d="M23.26 27.2686H20.24V19.0086C20.24 18.6752 20.2467 18.2286 20.26 17.6686C20.2733 17.0952 20.2933 16.5952 20.32 16.1686C20.2533 16.2486 20.1067 16.3952 19.88 16.6086C19.6667 16.8086 19.4667 16.9886 19.28 17.1486L17.64 18.4686L16.18 16.6486L20.78 12.9886H23.26V27.2686Z"
        fill="white"
      />
      <foreignObject className="node" x="46" y="22" width="200" height="300">
        <TutorialContent>
          click SET THE DATE <br />
          and start countdown <br />
          to your IPO. <br />
        </TutorialContent>
      </foreignObject>

      <defs>
        <filter
          id="filter0_d_2466_13459"
          x="20"
          y="5"
          width="295"
          height="119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2466_13459" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2466_13459"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </SetTheDateTutorialStyled>
)

export default SetTheDateTutorial
